import React from "react";

const LANDING_URL = (process.env.REACT_APP_LANDING_URL ?? "http://localhost:8000").replace(/\/+$/, "");

const WebMenuLandingFooter = () => (
    <footer
        className="position-fixed start-0 end-0 bottom-0 w-100 px-2 pt-2 bg-white shadow-lg z-1"
        style={{
            height: "calc(3rem + env(safe-area-inset-bottom, 0px))",
            paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom, 0px))",
        }}
    >
        <p className="m-0 text-center text-dark lh-sm text-break small">
            <a
                href={LANDING_URL}
                className="fw-bold text-reset text-decoration-underline"
                target="_blank"
                rel="noopener noreferrer"
            >
                <span className="text-dark">KIOSK</span>
                <span className="text-success">QR</span>
            </a>
            {" - Phần mềm menu QR gọi món tại bàn cho quán cafe và nhà hàng"}
        </p>
    </footer>
);

export default WebMenuLandingFooter;
